module.exports = __webpack_public_path__ + "static/img/ActPoster_sunlands_test.438a266.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active1017/ActPoster_sunlands_test.png
// module id = KdeG
// module chunks = 0